/**
 * Load all number formats in json format for the vue views
 *
 * @returns {{}} an object with all supported number formats
 */
export default function loadNumberFormats() {
    return {
        'en-US': {
            currency: {
                style: 'currency',
                currency: 'USD',
                currencyDisplay: 'symbol'
            }
        },
        'en': {
            currency: {
                style: 'currency',
                currency: 'USD',
                currencyDisplay: 'symbol'
            }
        },
        'de-DE': {
            currency: {
                style: 'currency',
                currency: 'EUR',
                currencyDisplay: 'symbol'
            }
        },
        'de': {
            currency: {
                style: 'currency',
                currency: 'EUR',
                currencyDisplay: 'symbol'
            }
        }
    }
}
